// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__KUqpX","tab":"styles_tab__Ec5RH","active":"styles_active__oDHX1","highlight":"styles_highlight__hhFoO"};